<template>
  <div class="table-chart">
    <el-table
      :data="pageData"
      stripe
      :height="height"
      @sort-change="sortChange"
      @row-click="rowClick"
    >
      <el-table-column
        v-for="c in calculatedColumns"
        :key="c.key"
        :prop="c.key"
        :label="c.label"
        :formatter="c.formatter"
        :class-name="c.className"
        :align="c.align"
        sortable="custom"
      ></el-table-column>
    </el-table>
    <br>
    <div class="text-center">
      <el-pagination :total="data.length" :page-size="pageSize" :current-page.sync="currentPage"></el-pagination>
    </div>
  </div>
</template>
<style lang="scss">
.table-chart {
    .cell {
        cursor: pointer;
    }
}
</style>

<script>
import _ from 'lodash';
import numeral from 'numeral';

export default {
    data: function() {
        return {
            pageSize: 50,
            currentPage: 1,
            numericCols: ['count', 'porcentaje_sum'],
            moneyCols: ['sum'],
            orderProp: null,
            order: null,
            aliases: {
                partida: 'Institución',
                capitulo: 'Servicio',
                count: 'Nº Documentos',
                subtitulo: 'Denominación Presupuestaria',
                sum: 'Total'
            }
        };
    },
    props: ['data', 'height'],
    computed: {
        columns: function() {
            return _(this.data[0])
                .map((d, key) => {
                    return {
                        key: key,
                        label: _.get(
                            this.aliases,
                            key,
                            _.capitalize(_.lowerCase(key))
                        ),
                        formatter: (row, column, cellValue, index) => {
                            if (this.moneyCols.indexOf(column.property) >= 0)
                                return numeral(cellValue).format('$0,0');
                            else if (
                                this.numericCols.indexOf(column.property) >= 0
                            )
                                return numeral(cellValue).format('0,0');
                            else return row['nombre_' + column.property];
                        },
                        className:
                            this.numericCols.indexOf(key) >= 0 ? 'amount' : '',
                        align:
                            this.numericCols.indexOf(key) >= 0 ||
                            this.moneyCols.indexOf(key) >= 0
                                ? 'right'
                                : 'left'
                    };
                })
                .filter(d => {
                    return !_.startsWith(d.key, 'nombre_');
                })
                .value();
        },
        calculatedColumns: function() {
            return [].concat(
                ...this.columns.map(d => {
                    if (this.moneyCols.indexOf(d.key) >= 0) {
                        let percentageCol = _.clone(d);
                        percentageCol.key = 'porcentaje_' + d.key;
                        percentageCol.label = 'Porcentaje';
                        percentageCol.className = 'percentage';
                        percentageCol.formatter = (
                            row,
                            column,
                            cellValue,
                            index
                        ) => {
                            return numeral(cellValue).format('0.00%');
                        };

                        return [d, percentageCol];
                    } else {
                        return [d];
                    }
                })
            );
        },
        totals: function() {
            let totals = {};
            this.moneyCols.forEach(d => {
                totals[d] = _.sumBy(this.data, d);
            });

            return totals;
        },
        offset: function() {
            return (this.currentPage - 1) * this.pageSize;
        },
        pageData: function() {
            return _(this.data)
                .orderBy(this.orderProp, this.order)
                .slice(this.offset, this.offset + this.pageSize)
                .map(row => {
                    let newRow = _.clone(row);
                    _.forEach(row, (d, key) => {
                        if (this.moneyCols.indexOf(key) >= 0) {
                            newRow['porcentaje_' + key] = d / this.totals[key];
                        }
                    });
                    return newRow;
                })
                .value();
        }
    },
    methods: {
        sortChange: function(column) {
            if (column.prop.indexOf('porcentaje_') === 0) {
                column.prop = column.prop.substr(column.prop.indexOf('_') + 1);
            }
            this.orderProp =
                this.numericCols.indexOf(column.prop) >= 0 ||
                this.moneyCols.indexOf(column.prop) >= 0
                    ? column.prop
                    : 'nombre_' + column.prop;
            this.order = column.order === 'ascending' ? 'asc' : 'desc';
        },
        rowClick: function(row, event, column) {
            this.$emit('detail-clicked', row);
        }
    }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/Components/Charts/Table.vue